import {getIotDeviceData} from 'iqos-mw';

import iccService from '@/services/icc/iccService';
import log from '@/services/logger/log';
import {
    setDeviceData,
    setHolderData,
    updateConnectedDeviceData,
    updateConnectedHolderData,
} from '@/state/slices/deviceSlice';
import {dispatch} from '@/state/store';

const getUamInfo = async ({codentify, onError, isHolder}) => {
    const onErrorHandler = (error) => {
        log.info(`Get Uam data. Failed. isHolder: ${isHolder}. error: ${JSON.stringify(error)}`);
        onError?.();
    };

    try {
        const uamTokenData = await iccService.fetchUamToken({codentify});

        const deviceInfo = await getIotDeviceData({
            uamTokenData,
            isHolder,
        });

        if (!deviceInfo.device) {
            onErrorHandler?.('No Device Data in Uam info.');
            return;
        }

        setUamInfo(isHolder, deviceInfo);
    } catch (e) {
        onErrorHandler?.(e);
    }
};

const setUamInfo = (isHolder, data) => {
    if (isHolder) {
        dispatch(setHolderData(data));
    } else {
        dispatch(setDeviceData(data));
    }
};

const updateConnectedUamInfo = (isHolder, data) => {
    if (isHolder) {
        dispatch(updateConnectedHolderData(data));
    } else {
        dispatch(updateConnectedDeviceData(data));
    }
};

export default {
    getUamInfo,
    updateConnectedUamInfo,
};
